import { render, staticRenderFns } from "./DocumentModalEdit.vue?vue&type=template&id=4a61a50b&"
import script from "./DocumentModalEdit.vue?vue&type=script&lang=js&"
export * from "./DocumentModalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports